import React from 'react';
import { Language } from '../types';

interface SourceListProps {
  sources: string[];
  language: Language;
}

const SourceList: React.FC<SourceListProps> = ({ sources, language }) => {
  if (sources.length === 0) return null;

  const label = language === 'fa' 
    ? 'منابع استفاده شده (Google Search):' 
    : 'Sources used (Google Search):';

  return (
    <div className={`mt-8 p-4 bg-gray-50 dark:bg-slate-800 rounded-lg border border-gray-200 dark:border-slate-700 ${language === 'fa' ? 'text-right' : 'text-left'}`}>
      <h4 className="text-sm font-bold text-gray-500 dark:text-gray-400 mb-2">{label}</h4>
      <div className={`flex flex-wrap gap-2 ${language === 'en' ? 'justify-start' : 'justify-start'}`}>
        {sources.map((url, idx) => {
          try {
            const domain = new URL(url).hostname.replace('www.', '');
            return (
              <a
                key={idx}
                href={url}
                target="_blank"
                rel="noreferrer"
                className="text-xs text-indigo-600 dark:text-indigo-400 bg-white dark:bg-slate-700 px-2 py-1 rounded border border-gray-200 dark:border-slate-600 hover:underline truncate max-w-[200px]"
              >
                {domain}
              </a>
            );
          } catch {
            return null;
          }
        })}
      </div>
    </div>
  );
};

export default SourceList;